import React, { useState } from 'react';

interface ToggleSwitchProps {
    isOn: boolean;
    setIsOn: (value: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ isOn, setIsOn }) => {
    const toggleSwitch = () => {
        setIsOn(!isOn);
    };

    return (
        <div>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                    type="checkbox"
                    checked={isOn}
                    onChange={toggleSwitch}
                    style={{ display: 'none' }} 
                />
                <div
                    style={{
                        width: '50px',
                        height: '25px',
                        backgroundColor: isOn ? '#6495ED' : 'gray',
                        borderRadius: '25px',
                        position: 'relative',
                        transition: 'background-color 0.3s'
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: '2px',
                            left: '2px',
                            width: '21px',
                            height: '21px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            transition: 'left 0.3s'
                        }}
                    >
                        {isOn ? '✓' : '✖'} 
                    </div>
                </div>
            </label>
        </div>
    );
};

export default ToggleSwitch;
